import { I18n } from '@aws-amplify/core';
import { Button, Flex, useTheme, CheckboxField } from '@aws-amplify/ui-react';
import { CircularProgress } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Auth } from 'aws-amplify';
import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Branding, theme } from '../../branding';
import { generateSession } from "../../common/service";
import { setTOS } from "../../redux/actions";
import CardMedia from '@material-ui/core/CardMedia';
import { format } from 'date-fns'
import Footer from '../Footer/Footer';



const config = require("Config");


const useStyles = makeStyles((theme) => ({

    rootGrid: {
        marginTop: theme.spacing(10),
        paddingBottom: theme.spacing(3),
    },
    grid: {
        justifyContent: 'center',
    },
    box: {
        width: '90%',
        maxWidth: 650,
    },
    card: {
        minWidth: "25em",
        maxWidth: '27em',
    },
    cardMedia: {
        width: 200,
        height: 90,
        backgroundSize: 'contain',
    },
    cardHeader: {
        paddingBottom: 0
    },
    cardContent: {
        justifyContent: 'left',
        display: 'flex',
        padding: "4em 2em",
        textAlign: 'left',
        "&:last-child": {
            paddingBottom: theme.spacing(5)
        }
    },
    boxExpandIdp: {
        textAlign: 'center',
    },
    chipExpand: {
        backgroundColor: Branding.secondary,
        color: Branding.white,
        '&:hover': {
            backgroundColor: Branding.secondary,
            opacity: Branding.opacityHover,
        },
    },
    expandIcon: {
        color: Branding.white,
    },
    divider: {
        marginBottom: theme.spacing(2)
    },
    typoToS: {
        paddingTop: theme.spacing(3),

    },
    linkTos: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.secondary,
        '&:hover': {
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    linkImprint: {
        fontSize: 14,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    link: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.link,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    midBul: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        color: Branding.secondary,
    },
    button: {
        width: "100%",
        borderRadius: "0px",
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    errorMessage: {
        color: "red",
        marginTop: theme.spacing(1),
        fontWeight: "bold",
        fontSize: "12px"
    }
}));

const mapStateToProps = (state) => {
    return {
        lang: state.app.lang,
        user: state.app.user,
        tos: state.app.tos,
    }
}

const TermsOfService = (props) => {
    const navigate = useNavigate();
    const { tokens } = useTheme();
    const classes = useStyles();
    const [isLoading, setIsLoading] = React.useState(false);
    const [tosAccepted, setTosAccepted] = React.useState(false);

    const updateTermsOfService = async (e) => {

        e.preventDefault();
        setIsLoading(true);

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        await Auth.updateUserAttributes(props.user, { "custom:tos_version": props.tos._id });
        props.tos.isAgreed = true;
        fetch(`${config.gusHostName}/v2/me/termsOfUse/${props.tos._id}/agree`, requestOptions).then(async (response) => {
            if (!response.ok) {
                console.log(response);
            }
            props.setTOS(props.tos);
            navigate("/", { replace: true });
        }).catch((error) => {
            console.log(error);
            props.setTOS(props.tos);
            navigate("/", { replace: true });
        });

    };

    const handleTOSClick = (event) => {
        setTosAccepted(!tosAccepted);
    }

    React.useEffect(() => {
        if (!props.user || !props.tos)
            return navigate("/", { replace: true });
        generateSession(props);
    }, []);

    return (
        <div>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                className={classes.rootGrid}
            >
                <CardMedia
                    className={classes.cardMedia}
                    image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
                    title={Branding.appName}
                />
            </Grid>

            <Grid container className={classes.grid}>
                <Card variant="outlined" className={classes.card}>
                    <CardContent className={classes.cardContent}>

                        <Flex as="form" direction="column" gap={tokens.space.medium}>
                            <div style={{ fontSize: "12px", textAlign: "justify" }}>
                                <div>
                                    <p>
                                        Our Terms of Service have been updated, effective as of {format(new Date(props?.tos?.releaseDate), 'MM/dd/yyyy')}. The updated Terms and Conditions reflect changes to our policies and practices in response to evolving business needs and legal requirements.
                                    </p>
                                </div>
                            </div>
                            <CheckboxField
                                name="custom:tos_signed"
                                onChange={handleTOSClick}
                                value={true}
                                label={
                                    <Typography style={{ fontSize: "12px" }}>
                                        I agree with the
                                        <a style={{ marginLeft: theme.spacing(0.5) }} href={props?.tos?.url || "https://www.youscience.com/terms-of-service/"}
                                            target="_blank" className={classes.link}>Terms of Service
                                        </a>
                                    </Typography>
                                }
                            />
                            <Button disabled={!tosAccepted} variation={!isLoading ? "primary" : "secondary"} className={classes.button} type="submit" onClick={updateTermsOfService}>
                                {isLoading ? <div style={{ display: "flex", alignItems: "center" }}>
                                    <CircularProgress variant='indeterminate' thickness={2} size={"1em"} /> <span style={{ marginLeft: "5px" }}>Please wait...</span></div> : 'I Agree'}
                            </Button>
                        </Flex>

                    </CardContent>
                </Card >
            </Grid>
            <Footer></Footer>
        </div >
    );
}

export default connect(mapStateToProps, { setTOS })(TermsOfService);